module.exports = __webpack_public_path__ + "static/e-banquet-illu-1-b59ca1dcf8afb6b0601e9349809c0b65.png";